var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Device, useShowToast } from "@madmedical/ui";
import { useGenerateDeepLinkUrl, useGenerateUrl } from "@madmedical/config";
import { useTranslation } from "@madmedical/i18n";
import { useConnectOauthMutation, useDisconnectOauthMutation } from "../api";
import openAuth from "../openAuth";
import useDevice from "../useDevice";
const CloudDevice = ({ device, canAddDevice, showAppDownload, onDismissAppDownload, }) => {
    const [connect, { isLoading: isConnecting }] = useConnectOauthMutation();
    const [disconnect, { isLoading: isDisconnecting }] = useDisconnectOauthMutation();
    const { refetch, isFetching: isRefetching } = useDevice(device.provider);
    const generateUrl = useGenerateUrl();
    const generateDeepLinkUrl = useGenerateDeepLinkUrl();
    const showToast = useShowToast();
    const { t } = useTranslation();
    const handleConnectPress = () => {
        openAuth(() => __awaiter(void 0, void 0, void 0, function* () {
            const { authUrl } = yield connect({
                provider: device.provider,
                returnUrl: generateUrl("/oauth-result"),
            }).unwrap();
            return authUrl;
        }), generateDeepLinkUrl("/"), // Android needs this ¯\_(ツ)_/¯
        (result) => {
            if (result === "success") {
                showToast(t("successfulConnection"), {
                    variant: "success",
                });
                void refetch();
            }
            else {
                showToast(t("unsuccessfulConnection"), {
                    variant: "error",
                });
            }
        });
    };
    const handleDisconnectPress = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield disconnect({ provider: device.provider }).unwrap();
            showToast(t("deviceDisconnected"), { variant: "success" });
        }
        catch (e) {
            console.error(e);
            showToast(t("deviceDisconnectedUnsuccessful"), {
                variant: "error",
            });
        }
    });
    return (_jsx(Device, { device: device, protocols: [], onConnectPress: handleConnectPress, onDisconnectPress: handleDisconnectPress, canAddDevice: canAddDevice, isConnectLoading: isConnecting || isDisconnecting || isRefetching, showAppDownload: showAppDownload, onDismissAppDownload: onDismissAppDownload }));
};
export default CloudDevice;
